import { Component, Inject, OnInit } from '@angular/core';
import {
  CompensationCategoryConditionEnum,
  CompensationCategoryModel
} from '@bo-client/activation-management/shared/models/compensationCategoryModel';
import { uri } from '@bo-client/shared/constants/uri';
import { isNumber } from 'lodash';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-compensation-categories-selection-modal',
  templateUrl: './show-compensation-categories-selection-modal.component.html',
  styleUrls: ['./show-compensation-categories-selection-modal.component.scss']
})
export class ShowCompensationCategoriesSelectionModalComponent implements OnInit {
  preSelectedCategories: CompensationCategoryModel[];
  availableCategories: CompensationCategoryModel[] = [];
  selectedCategories: CompensationCategoryModel[] = [];

  constructor(
    private httpHapService: HttpHapService,
    @Inject(MAT_DIALOG_DATA) public inputData: { preSelectedCategories: CompensationCategoryModel[] },
    public dialogRef: MatDialogRef<ShowCompensationCategoriesSelectionModalComponent>
  ) {}

  ngOnInit() {
    this.preSelectedCategories = this.inputData.preSelectedCategories;
    this.getAvailableCompensationCategories();
  }

  getAvailableCompensationCategories() {
    this.httpHapService.get(uri.cmCompCat + uri.getAll).subscribe((answer: CompensationCategoryModel[]) => {
      const notNullAnswer = answer.filter((x) => x.powerRange && isNumber(x.compensationAmount) && x.name);
      const allCategories = this.sortListByPowerRange(this.filterPowerRange(notNullAnswer));
      this.availableCategories = allCategories.filter((element: CompensationCategoryModel) => {
        return !this.preSelectedCategories.some(
          (preSelectedElement: CompensationCategoryModel) => preSelectedElement.id === element.id
        );
      });
    });
  }

  toggleSelectCompensationCategory(compensationCategory: CompensationCategoryModel) {
    if (this.elementIsSelected(compensationCategory)) {
      this.selectedCategories = this.selectedCategories.filter(
        (element) => element.id !== compensationCategory.id
      );
    } else {
      this.selectedCategories.push(compensationCategory);
    }
  }

  elementIsSelected(compensationCategory: CompensationCategoryModel) {
    return this.selectedCategories.some(
      (element: CompensationCategoryModel) => element.id === compensationCategory.id
    );
  }

  sortListByPowerRange(list: CompensationCategoryModel[]) {
    return list.sort((a, b) => (a.powerRange < b.powerRange ? -1 : a.powerRange > b.powerRange ? 1 : 0));
  }

  filterPowerRange(list: CompensationCategoryModel[]): CompensationCategoryModel[] {
    const regex = /\d+/g;
    list = list.filter((x) => {
      if (x.powerRange === CompensationCategoryConditionEnum.None) {
        return true;
      }
      const values: string[] = x.powerRange.split('_');
      return +values[1].match(regex) !== null;
    });
    return list;
  }

  save() {
    if (this.selectedCategories.length > 0) {
      this.dialogRef.close(this.selectedCategories);
    }
  }

  close() {
    this.dialogRef.close([]);
  }
}
